export default "__VITE_ASSET__db7733c3__"